module.exports = "<div class=\"b3-stats-cell__value\">{{ currentValue }}</div>\n<div class=\"b3-stats-cell__signals\">шт</div>\n"